const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Webhooks de Eventos",
    summary:
      "Notifica a tus sistemas en tiempo real sobre eventos clave de la plataforma: creación de tickets, mensajes entrantes, cambios de estado, resolución de conversaciones o nuevos contactos.",
  },
  sections: [
    {
      id: "configuracion_webhooks",
      title: "1. Configuración de Webhooks",
      description:
        "Registro de URL de destino, cabeceras personalizadas y selección de eventos escuchados.",
      items: [
        {
          id: "url_webhook",
          title: "URL de Destino",
          definition:
            "Dirección HTTPS pública de tu servidor o middleware que procesará los eventos entrantes mediante método POST.",
        },
        {
          id: "eventos_escuchados",
          title: "Suscripción a Eventos",
          definition:
            "Selecciona qué sucesos dispararán el webhook: nuevo ticket, mensaje recibido, ticket cerrado o contacto actualizado.",
        },
      ],
    },
    {
      id: "historial_entregas",
      title: "2. Monitoreo y Reintentos",
      description:
        "Registro de entregas, códigos de respuesta HTTP y reintentos ante fallas temporales.",
      items: [
        {
          id: "logs_webhook",
          title: "Historial de Peticiones",
          definition:
            "Consulta los payloads enviados, tiempos de respuesta y códigos de estado (200 OK, 500 Error) para auditoría técnica.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Event Webhooks",
    summary:
      "Notify your external platforms in real time about key events: ticket creation, inbound messages, status changes, ticket resolution, or contact updates.",
  },
  sections: [
    {
      id: "configuracion_webhooks",
      title: "1. Webhook Setup",
      description:
        "Destination URLs, custom headers, and granular event subscriptions.",
      items: [
        {
          id: "url_webhook",
          title: "Endpoint Target URL",
          definition:
            "Public HTTPS address of your server or webhook receiver that handles incoming JSON payloads via POST.",
        },
        {
          id: "eventos_escuchados",
          title: "Event Subscriptions",
          definition:
            "Choose triggers: ticket created, message received, ticket resolved, or contact modified.",
        },
      ],
    },
    {
      id: "historial_entregas",
      title: "2. Delivery Logs & Retries",
      description:
        "Track delivery status, HTTP response codes, and network retries.",
      items: [
        {
          id: "logs_webhook",
          title: "Dispatch Logs",
          definition:
            "Inspect transmitted payloads, response times, and HTTP codes (200 OK, 500 Error) for diagnostics.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Webhooks de Eventos",
    summary:
      "Notifique sistemas externos em tempo real sobre eventos ocorridos na plataforma: abertura de tickets, mensagens recebidas, alterações de status e novos contatos.",
  },
  sections: [
    {
      id: "configuracion_webhooks",
      title: "1. Configuração de Webhooks",
      description:
        "URL de destino, cabeçalhos de segurança e seleção de eventos acionadores.",
      items: [
        {
          id: "url_webhook",
          title: "URL de Destino",
          definition:
            "Endereço HTTPS público do seu servidor que receberá os payloads JSON via requisições POST.",
        },
        {
          id: "eventos_escuchados",
          title: "Assinatura de Eventos",
          definition:
            "Escolha quais eventos disparam notificações: ticket criado, mensagem recebida ou conversa finalizada.",
        },
      ],
    },
    {
      id: "historial_entregas",
      title: "2. Monitoramento e Logs",
      description:
        "Histórico de disparos, códigos HTTP e reenvios automáticos.",
      items: [
        {
          id: "logs_webhook",
          title: "Logs de Entrega",
          definition:
            "Analise os dados enviados, tempo de resposta e status HTTP (200 OK, 500 Erro) para depuração técnica.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Webhooks d'Événements",
    summary:
      "Alertez vos applications externes en temps réel lors des événements majeurs : création de tickets, messages reçus, clôtures d'échanges ou mise à jour de contacts.",
  },
  sections: [
    {
      id: "configuracion_webhooks",
      title: "1. Configuration des Webhooks",
      description:
        "URL cible, en-têtes personnalisés et choix des événements.",
      items: [
        {
          id: "url_webhook",
          title: "URL de Destination",
          definition:
            "Adresse HTTPS publique de votre serveur qui traitera les charges utiles JSON par méthode POST.",
        },
        {
          id: "eventos_escuchados",
          title: "Souscription aux Événements",
          definition:
            "Sélectionnez les déclencheurs pertinents : nouveau ticket, message entrant ou mise à jour du profil.",
        },
      ],
    },
    {
      id: "historial_entregas",
      title: "2. Historique et Surveillance",
      description:
        "Suivi des livraisons, codes de statut HTTP et diagnostics d'erreurs.",
      items: [
        {
          id: "logs_webhook",
          title: "Journal des Envois",
          definition:
            "Consultez les données transmises, temps d'exécution et réponses du serveur pour vérification.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "إشعارات الويب للأحداث (Event Webhooks)",
    summary:
      "أرسل إشعارات فورية لأنظمتك الخارجية عند وقوع أحداث رئيسية: فتح تذكرة جديدة، استقبال رسالة، تغيير الحالة، أو تحديث بيانات جهة الاتصال.",
  },
  sections: [
    {
      id: "configuracion_webhooks",
      title: "1. إعداد Webhook",
      description:
        "رابط الاستقبال والترويسات المخصصة وتحديد الأحداث المشتركة.",
      items: [
        {
          id: "url_webhook",
          title: "رابط الوجهة (Endpoint)",
          definition:
            "عنوان HTTPS العام لخادمك لاستقبال حزم بيانات JSON عبر طلبات POST.",
        },
        {
          id: "eventos_escuchados",
          title: "الاشتراك في الأحداث",
          definition:
            "حدد الأحداث المطلوبة: إنشاء تذكرة، استلام رسالة، إغلاق محادثة أو تعديل جهة اتصال.",
        },
      ],
    },
    {
      id: "historial_entregas",
      title: "2. السجلات والمراقبة",
      description:
        "تتبع حالات التسليم ورموز استجابة HTTP ومحاولات إعادة الإرسال.",
      items: [
        {
          id: "logs_webhook",
          title: "سجل الإرسال",
          definition:
            "افحص بيانات الحمولات المرسلة وأوقات الاستجابة ورموز الحالة لأغراض التشخيص الفني.",
        },
      ],
    },
  ],
};

export const EVENT_WEBHOOKS_HELP_DATA = { es, en, pt, fr, ar };
export default EVENT_WEBHOOKS_HELP_DATA;
